window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Background_Blue = function() {
	this.initialize(img.SplashAssets_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.Button_disabled = function() {
	this.initialize(img.SplashAssets_Button_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_down = function() {
	this.initialize(img.SplashAssets_Button_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_up = function() {
	this.initialize(img.SplashAssets_Button_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.FeedbackPopup_Left = function() {
	this.initialize(img.SplashAssets_FeedbackPopup_Left);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.FeedbackPopup_Middle = function() {
	this.initialize(img.SplashAssets_FeedbackPopup_Middle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,126,75);


(lib.FeedbackPopup_Right = function() {
	this.initialize(img.SplashAssets_FeedbackPopup_Right);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.Racing_Illustration = function() {
	this.initialize(img.SplashAssets_Racing_Illustration);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,976,2052);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.TextSamplesSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// tf
	this.textfield1 = new cjs.Text("Font", "120px 'Roboto'", "#FF0000");
	this.textfield1.name = "textfield1";
	this.textfield1.lineHeight = 144;
	this.textfield1.lineWidth = 353;
	this.textfield1.parent = this;
	this.textfield1.setTransform(90.05,71.3);
ranj.TextOffsetFixer.fix(this.textfield1);

	this.timeline.addTween(cjs.Tween.get(this.textfield1).wait(1));

	// tf
	this.textfield2 = new cjs.Text("Font ", "60px 'Roboto'");
	this.textfield2.name = "textfield2";
	this.textfield2.lineHeight = 72;
	this.textfield2.lineWidth = 282;
	this.textfield2.parent = this;
	this.textfield2.setTransform(95,85.6);
ranj.TextOffsetFixer.fix(this.textfield2);

	this.timeline.addTween(cjs.Tween.get(this.textfield2).wait(1));

	// tf
	this.textfield2_1 = new cjs.Text("Font ", "30px 'Roboto'", "#0000FF");
	this.textfield2_1.name = "textfield2_1";
	this.textfield2_1.lineHeight = 36;
	this.textfield2_1.lineWidth = 93;
	this.textfield2_1.parent = this;
	this.textfield2_1.setTransform(97.45,92.8);
ranj.TextOffsetFixer.fix(this.textfield2_1);

	this.timeline.addTween(cjs.Tween.get(this.textfield2_1).wait(1));

	// guide 
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0000FF").ss(1,1,1,3,true).p("AAAAAIAAH0AH0AAIn0AAAAAnzIAAHzInzAA");
	this.shape.setTransform(100,100);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TextSamplesSkin, new cjs.Rectangle(49,49,1091.3,902.2), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Racing_Illustration();
	this.instance.setTransform(-667,-1445,1.3669,1.367);

	this.instance_1 = new lib.Background_Blue();
	this.instance_1.setTransform(-667,-1286,1.3655,1.3655);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-667,-1445,1334.1,2961), null);


(lib.LoadingBarBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.bf(img.SplashAssets_Button_up, null, new cjs.Matrix2D(1.012,0,0,1,-218.9,-85)).s().p("A3+AeIAAg7MAv8AAAIAAA7g");
	this.shape.setTransform(153.45,3.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBarBar, new cjs.Rectangle(0,0.5,306.9,6), null);


(lib.FeedbackPopupBG_Right = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Right();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Right, new cjs.Rectangle(0,0,50,75), null);


(lib.FeedbackPopupBG_Middle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Middle();
	this.instance.setTransform(-6,0,1.1123,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Middle, new cjs.Rectangle(-6,0,140.2,75), null);


(lib.FeedbackPopupBG_Left = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Left();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Left, new cjs.Rectangle(0,0,50,75), null);


(lib.StartGameButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("start", "20px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 24;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-13.9);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("start", "20px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 24;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-13.9);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("start", "20px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 24;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-13.9);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("start", "20px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 24;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-13.9);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.LoadingBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_99 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(99).call(this.frame_99).wait(1));

	// LoadingBarBar
	this.instance = new lib.LoadingBarBar();
	this.instance.setTransform(3.75,10,0.0227,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:0.9401},99).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#EDF0F5").s().p("A2zAyIAAhjMAtnAAAIAABjg");
	this.shape.setTransform(147.85,13.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(100));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(1.9,8.5,292,10);


(lib.FeedbackPopupBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bgRight = new lib.FeedbackPopupBG_Right();
	this.bgRight.name = "bgRight";
	this.bgRight.setTransform(200.5,37.5,1,1,0,0,0,25,37.5);

	this.bgMid = new lib.FeedbackPopupBG_Middle();
	this.bgMid.name = "bgMid";
	this.bgMid.setTransform(113,37.5,1,1,0,0,0,63,37.5);

	this.bgLeft = new lib.FeedbackPopupBG_Left();
	this.bgLeft.name = "bgLeft";
	this.bgLeft.setTransform(25.5,37.5,1,1,0,0,0,25,37.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bgLeft},{t:this.bgMid},{t:this.bgRight}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG, new cjs.Rectangle(0.5,0,225,75), null);


(lib.FeedbackPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// body
	this.bodyTextfield = new cjs.Text("abcdef ", "italic 40px 'Roboto'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "center";
	this.bodyTextfield.lineHeight = 49;
	this.bodyTextfield.lineWidth = 149;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-0.7498,9.8);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// Layer_2
	this.bg = new lib.FeedbackPopupBG();
	this.bg.name = "bg";
	this.bg.setTransform(-2,34.25,1,1,0,0,0,112,37.5);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPanel, new cjs.Rectangle(-113.5,-3.2,225,78.4), null);


(lib.SplashLoadScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// feedback
	this.startFeedback = new lib.FeedbackPanel();
	this.startFeedback.name = "startFeedback";
	this.startFeedback.setTransform(-16,694.15,1,1,0,0,0,-1,36);

	this.timeline.addTween(cjs.Tween.get(this.startFeedback).wait(1));

	// startbutton
	this.startButton = new lib.StartGameButton();
	this.startButton.name = "startButton";
	this.startButton.setTransform(-19.25,691.35,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get(this.startButton).wait(1));

	// loadingTextField
	this.loadingTextField = new cjs.Text("loading", "13px 'Roboto Medium'", "#FFFFFF");
	this.loadingTextField.name = "loadingTextField";
	this.loadingTextField.textAlign = "center";
	this.loadingTextField.lineHeight = 16;
	this.loadingTextField.lineWidth = 288;
	this.loadingTextField.parent = this;
	this.loadingTextField.setTransform(-14.6,746.25,2.7273,2.7273);
ranj.TextOffsetFixer.fix(this.loadingTextField);

	this.timeline.addTween(cjs.Tween.get(this.loadingTextField).wait(1));

	// versionTextField
	this.versionTextField = new cjs.Text("v1.0.12 commitslug", "italic 14px 'Roboto'", "#999999");
	this.versionTextField.name = "versionTextField";
	this.versionTextField.textAlign = "right";
	this.versionTextField.lineHeight = 17;
	this.versionTextField.lineWidth = 199;
	this.versionTextField.parent = this;
	this.versionTextField.setTransform(515.6,803.55,2.7273,2.7273);
ranj.TextOffsetFixer.fix(this.versionTextField);

	this.timeline.addTween(cjs.Tween.get(this.versionTextField).wait(1));

	// titleTextField
	this.bodyTextfield = new cjs.Text("Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here ", "38px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 55;
	this.bodyTextfield.lineWidth = 875;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-431.8,-578.4527,0.9999,0.9999);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.titleTextfield = new cjs.Text("Minigame", "108px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 130;
	this.titleTextfield.lineWidth = 867;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-431.8,-793.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.titleTextfield},{t:this.bodyTextfield}]}).wait(1));

	// loadingBar
	this.loadingBar = new lib.LoadingBar();
	this.loadingBar.name = "loadingBar";
	this.loadingBar.setTransform(13.2,722.45,2.7273,2.7273,0,0,0,157.6,12.3);

	this.timeline.addTween(cjs.Tween.get(this.loadingBar).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SplashLoadScreenSkin, new cjs.Rectangle(-667.5,-1445,1746.9,2961), null);


// stage content:
(lib.SplashAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// TextSamplesSkin
	this.instance = new lib.TextSamplesSkin();
	this.instance.setTransform(-752.35,-370.55);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.instance_1 = new lib.SplashLoadScreenSkin();
	this.instance_1.setTransform(538.8,872,1,1,0,0,0,-1.2,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-181.1,297,1388.1999999999998,2090);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/SplashAssets/Background_Blue.png", id:"SplashAssets_Background_Blue", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/Button_disabled.png", id:"SplashAssets_Button_disabled", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/Button_down.png", id:"SplashAssets_Button_down", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/Button_up.png", id:"SplashAssets_Button_up", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/FeedbackPopup_Left.png", id:"SplashAssets_FeedbackPopup_Left", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/FeedbackPopup_Middle.png", id:"SplashAssets_FeedbackPopup_Middle", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/FeedbackPopup_Right.png", id:"SplashAssets_FeedbackPopup_Right", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/Racing_Illustration.png", id:"SplashAssets_Racing_Illustration", bundle:"SplashAssets"}
	],
	preloads: []
};



})(lib.SplashAssets = {}, images, ss, createjs);
module.exports = lib.SplashAssets;